import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HomeIcon from '@mui/icons-material/Home';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import { Link, useLocation } from 'react-router-dom';
import './MobileBottomNav.css';

const destinations = [
  { label: 'Learn', path: '/', icon: <HomeIcon /> },
  { label: 'Dashboard', path: '/dashboard', icon: <DashboardIcon /> },
  { label: 'Courses', path: '/courses', icon: <AutoStoriesIcon /> },
  { label: 'Classes', path: '/classes', icon: <SchoolIcon /> },
  { label: 'Challenges', path: '/challenges', icon: <EmojiEventsIcon /> },
  { label: 'Students', path: '/students', icon: <PeopleIcon /> },
];

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const selected = destinations.find((item) => item.path === '/' ? pathname === '/' || pathname === '/Welcome' : pathname.startsWith(item.path))?.path || '';

  return (
    <Paper className="mobile-bottom-nav-shell" elevation={12}>
      <BottomNavigation showLabels value={selected} aria-label="Mobile navigation">
        {destinations.map((item) => <BottomNavigationAction component={Link} to={item.path} value={item.path} label={item.label} icon={item.icon} key={item.path} />)}
      </BottomNavigation>
    </Paper>
  );
}
